import { render } from "./HuaWeiInstall.vue?vue&type=template&id=6817420d"
import script from "./HuaWeiInstall.vue?vue&type=script&lang=js"
export * from "./HuaWeiInstall.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__